import { theme } from '../../../../theme';

const { colors } = theme;

export const SUBMISSION_BOM_STATUS_MAP = {
  2: 'Created',
  3: 'Failure'
};

export const SUBMISSION_KSF_STATUS_MAP = {
  2: '',
  3: 'Failure'
};

export const SUBMISSION_COLOR_MAP = {
  2: colors.successPrimary,
  3: colors.error
};
